(() => {
  const selector = '.product-card-wrapper .card__media img, .product__media img, .product-media-modal__content img, .thumbnail img, .cart-item__image, .predictive-search__image';
  const seen = new WeakMap();
  const cache = new Map();
  const isSignedPaperback = (img) => {
    const container = img.closest('.product-card-wrapper, .cart-item, .predictive-search__list-item');
    const productMedia = img.closest('.product, .product-media-modal');
    const title = container ? container.textContent : productMedia ? document.querySelector('h1')?.textContent || '' : '';
    return /\bsigned[\s_-]+paperback\b/i.test([img.alt, title, img.closest('a')?.getAttribute('href') || ''].join(' '));
  };
  const clean = async (img) => {
    const src = img.currentSrc || img.src;
    if (isSignedPaperback(img)) return;
    if (!src || src.includes('xmasvoucher.png') || seen.get(img) === src) return;
    seen.set(img, src);
    try {
      let task = cache.get(src);
      if (!task) {
        task = new Promise((resolve, reject) => {
          const source = new Image();
          source.crossOrigin = 'anonymous';
          source.onload = () => {
            try {
              const scale = Math.min(1, 1200 / Math.max(source.width, source.height));
              const w = Math.round(source.width * scale), h = Math.round(source.height * scale);
              const canvas = document.createElement('canvas');
              canvas.width = w; canvas.height = h;
              const ctx = canvas.getContext('2d', {willReadFrequently: true});
              ctx.drawImage(source, 0, 0, w, h);
              const pixels = ctx.getImageData(0, 0, w, h), d = pixels.data;
              let transparent = 0, edge = 0;
              for (let x=0;x<w;x++) { transparent += Number(d[x*4+3]<10)+Number(d[((h-1)*w+x)*4+3]<10); edge+=2; }
              for (let y=0;y<h;y++) { transparent += Number(d[y*w*4+3]<10)+Number(d[(y*w+w-1)*4+3]<10); edge+=2; }
              if (transparent / edge > .5) { resolve(null); return; }
              const protectedPixels = new Uint8Array(w*h);
              if (/BookBrushImage-2024-2-1[23]-/.test(src)) {
                const shield = document.createElement('canvas'); shield.width=w; shield.height=h;
                const sc=shield.getContext('2d'); sc.scale(w/720,h/720); sc.fillStyle='#fff';
                for (const [dx,dy] of [[0,0],[330,0],[4,335],[348,333]]) {
                  sc.beginPath();
                  [[88,38],[280,43],[303,332],[107,353]].forEach(([x,y],j)=>j?sc.lineTo(x+dx,y+dy):sc.moveTo(x+dx,y+dy)); sc.closePath();sc.fill();
                  sc.beginPath();
                  [[226,156],[258,146],[299,152],[330,176],[344,195],[342,239],[330,263],[282,280],[248,274],[230,252],[224,215]].forEach(([x,y],j)=>j?sc.lineTo(x+dx,y+dy):sc.moveTo(x+dx,y+dy));sc.closePath();sc.fill();
                }
                const sd=sc.getImageData(0,0,w,h).data;
                for(let p=0;p<w*h;p++) protectedPixels[p]=sd[p*4+3]>0?1:0;
              }
              const visited = new Uint8Array(w * h), queue = new Int32Array(w * h);
              let head = 0, tail = 0;
              const add = (p) => {
                if (visited[p] || protectedPixels[p]) return;
                visited[p] = 1;
                const i = p * 4, min = Math.min(d[i], d[i+1], d[i+2]), max = Math.max(d[i], d[i+1], d[i+2]);
                if (d[i+3] < 10 || (min >= 220 && max - min <= 28)) queue[tail++] = p;
              };
              for (let x = 0; x < w; x++) { add(x); add((h-1)*w+x); }
              for (let y = 0; y < h; y++) { add(y*w); add(y*w+w-1); }
              while (head < tail) {
                const p = queue[head++], x = p % w;
                if (x) add(p-1);
                if (x < w-1) add(p+1);
                if (p >= w) add(p-w);
                if (p < w*(h-1)) add(p+w);
              }
              if (tail < w*h*.002 || tail > w*h*.8) { resolve(null); return; }
              for (let i = 0; i < d.length; i+=4) { d[i]=255; d[i+1]=255; d[i+2]=255; d[i+3]=255; }
              for (let i = 0; i < tail; i++) d[queue[i]*4+3]=0;
              ctx.putImageData(pixels, 0, 0);
              resolve(canvas.toDataURL('image/png'));
            } catch (e) { reject(e); }
          };
          source.onerror = reject;
          source.src = src;
        });
        cache.set(src, task);
      }
      const mask = await task;
      if (mask && img.isConnected && (img.currentSrc || img.src) === src) {
        img.style.maskImage = `url("${mask}")`;
        img.style.webkitMaskImage = `url("${mask}")`;
        const fit = getComputedStyle(img).objectFit;
        img.style.maskSize = fit === 'contain' || fit === 'cover' ? fit : '100% 100%';
        img.style.webkitMaskSize = img.style.maskSize;
        img.style.maskPosition = getComputedStyle(img).objectPosition;
        img.style.maskRepeat = 'no-repeat';
        img.dataset.alphaCharcoal = 'true';
      }
    } catch (_) { seen.delete(img); }
  };
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { clean(entry.target); observer.unobserve(entry.target); }
  }), {rootMargin: '300px'});
  const scan = () => document.querySelectorAll(selector).forEach(img => observer.observe(img));
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches(selector)) observer.observe(event.target);
  }, true);
  let pending;
  new MutationObserver(() => { clearTimeout(pending); pending = setTimeout(scan, 100); })
    .observe(document.body, {childList: true, subtree: true});
  scan();
})();

